import {
  FETCH_COMPANY_PENDING,
  FETCH_COMPANY_SUCCESS,
  FETCH_COMPANY_FAIL,
  SAVE_COMPANY_KIOSK_ID,
} from '../../constants/action_types';
import { COMPANY_NAME } from '../../constants/kiosk_company_code_types';

export const fetchCompany = (companyCode, codeType = COMPANY_NAME) => {
  return async (dispatch, getState, services) => {
    const state = getState();
    if (!companyCode) {
      return dispatch(fetchCompanyFail('No company code'));
    }

    dispatch(fetchCompanyPending());

    try {
      const languageISOCode = state.languages.languageISO;
      const data = await services.fetchKioskCompany(languageISOCode, companyCode, codeType);

      dispatch(
        fetchCompanySuccess({
          companyCode,
          codeType,
          ...data,
        }),
      );
    } catch (err) {
      dispatch(fetchCompanyFail(err.message));
    }
  };
};

export const saveCompanyKioskId = (kioskId) => ({
  type: SAVE_COMPANY_KIOSK_ID,
  kioskId,
});

const fetchCompanyPending = () => ({
  type: FETCH_COMPANY_PENDING,
});

const fetchCompanySuccess = (data) => ({
  type: FETCH_COMPANY_SUCCESS,
  id: data.id,
  name: data.name,
  code: data.companyCode,
  codeType: data.codeType,
  logoUrl: data.logoFileName,
  brandColor: data.topbarColorHex,
  employeeIdTypes: data.idTypes,
  kioskId: data.kioskId,
  kioskWelcomeText: data.kioskWelcomeText,
});

const fetchCompanyFail = (error) => ({
  type: FETCH_COMPANY_FAIL,
  error,
});
